import { FC } from "react";
import { G, Path, Svg } from "react-native-svg";
import { tSvgProps } from "../types";

const PdImport: FC<tSvgProps> = (props) => {
  return (
    <Svg viewBox="0 0 95 95" fill="none" {...props}>
      <G transform="translate(-2.5,-2.4992)">
        <Path
          d="m 77.855,2.5 v 1.6523 h 17.023 l -70.762,70.355 1.1641,1.1719 70.758,-70.352 v 16.996 h 1.6523 V 2.4992"
          fill="currentColor"
        />
        <Path
          d="M 85.109,95.848 H 4.152 V 14.891 H 66.109 V 13.2387 H 2.5 v 84.262 h 84.262 v -63.195 h -1.6523 z"
          fill="currentColor"
        />
      </G>
    </Svg>
  );
};

export default PdImport;
